import {GoogleOAuthProvider} from '@react-oauth/google';
import {ComponentsProvider} from 'platform/components';

import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';

import {App} from './App';
import {GlobalStyles} from './GlobalStyles';
import {store} from './store';
import {theme} from './theme';

const GOOGLE_CLIENT_ID = '83352527444-1aqhqndjnlr3jhum4vub0vmtl3a90gp0.apps.googleusercontent.com';

createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <Provider store={store}>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <ComponentsProvider theme={theme} language="cs">
          <App />
          <GlobalStyles />
        </ComponentsProvider>
      </GoogleOAuthProvider>
    </Provider>
  </BrowserRouter>
);
